var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutSection6DownloadGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 53,
    viewBox: "0 0 180 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_177_705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2232 14.0454C63.2232 15.1117 62.8899 15.9656 62.2332 16.6025C61.4782 17.3575 60.4949 17.7374 59.2899 17.7374C58.1382 17.7374 57.1549 17.3511 56.3482 16.5897C55.5399 15.8172 55.1366 14.869 55.1366 13.7342C55.1366 12.5993 55.5399 11.6512 56.3482 10.885C57.1549 10.1172 58.1382 9.73096 59.2899 9.73096C59.8632 9.73096 60.4099 9.84429 60.9316 10.055C61.4516 10.2673 61.8749 10.5546 62.1816 10.9089L61.4849 11.5825C60.9499 10.9776 60.2216 10.6791 59.2899 10.6791C58.4499 10.6791 57.7216 10.96 57.1032 11.5267C56.4916 12.0949 56.1849 12.8307 56.1849 13.7342C56.1849 14.6376 56.4916 15.3798 57.1032 15.9481C57.7216 16.5083 58.4499 16.7956 59.2899 16.7956C60.1816 16.7956 60.9316 16.5083 61.5232 15.9417C61.9132 15.5666 62.1349 15.0494 62.1933 14.3886H59.2899V13.466H63.1632C63.2099 13.6655 63.2232 13.8587 63.2232 14.0454V14.0454Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3684 10.8469H65.73V13.2731H69.01V14.1957H65.73V16.6218H69.3684V17.562H64.7V9.90674H69.3684V10.8469Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7049 17.562H72.6749V10.8469H70.4433V9.90674H75.9383V10.8469H73.7049V17.562V17.562Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.915 17.562V9.90674H80.9434V17.562H79.915Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5017 17.562H84.48V10.8469H82.24V9.90674H87.7417V10.8469H85.5017V17.562Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1451 16.5769C97.3567 17.3511 96.3801 17.7374 95.2151 17.7374C94.0434 17.7374 93.0667 17.3511 92.2784 16.5769C91.4917 15.8044 91.1001 14.8563 91.1001 13.7342C91.1001 12.612 91.4917 11.6639 92.2784 10.8914C93.0667 10.1172 94.0434 9.73096 95.2151 9.73096C96.3734 9.73096 97.3501 10.1172 98.1384 10.8978C98.9317 11.6767 99.3234 12.6184 99.3234 13.7342C99.3234 14.8563 98.9317 15.8044 98.1451 16.5769ZM93.0401 15.9353C93.6334 16.5083 94.3551 16.7956 95.2151 16.7956C96.0684 16.7956 96.7967 16.5083 97.3834 15.9353C97.9751 15.3623 98.2751 14.6264 98.2751 13.7342C98.2751 12.8419 97.9751 12.1061 97.3834 11.533C96.7967 10.96 96.0684 10.6727 95.2151 10.6727C94.3551 10.6727 93.6334 10.96 93.0401 11.533C92.4484 12.1061 92.1484 12.8419 92.1484 13.7342C92.1484 14.6264 92.4484 15.3623 93.0401 15.9353V15.9353Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.768 17.562V9.90674H102.018L105.905 15.8605H105.95L105.905 14.3888V9.90674H106.933V17.562H105.86L101.79 11.3146H101.745L101.79 12.7926V17.562H100.768V17.562Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8466 28.7417C87.715 28.7417 85.1566 31.0242 85.1566 34.1735C85.1566 37.2972 87.715 39.6037 90.8466 39.6037C93.985 39.6037 96.5433 37.2972 96.5433 34.1735C96.5433 31.0242 93.985 28.7417 90.8466 28.7417ZM90.8466 37.4648C89.1283 37.4648 87.65 36.1065 87.65 34.1735C87.65 32.215 89.1283 30.8806 90.8466 30.8806C92.565 30.8806 94.05 32.215 94.05 34.1735C94.05 36.1065 92.565 37.4648 90.8466 37.4648V37.4648ZM78.4316 28.7417C75.2933 28.7417 72.7417 31.0242 72.7417 34.1735C72.7417 37.2972 75.2933 39.6037 78.4316 39.6037C81.5683 39.6037 84.1216 37.2972 84.1216 34.1735C84.1216 31.0242 81.5683 28.7417 78.4316 28.7417ZM78.4316 37.4648C76.7116 37.4648 75.2283 36.1065 75.2283 34.1735C75.2283 32.215 76.7116 30.8806 78.4316 30.8806C80.15 30.8806 81.6283 32.215 81.6283 34.1735C81.6283 36.1065 80.15 37.4648 78.4316 37.4648ZM63.6583 30.4065V32.7146H69.4133C69.245 34.0043 68.795 34.9524 68.105 35.6132C67.265 36.4113 65.9567 37.2972 63.6583 37.2972C60.1167 37.2972 57.3433 34.5598 57.3433 31.1679C57.3433 27.776 60.1167 25.0386 63.6583 25.0386C65.5733 25.0386 66.9667 25.7553 67.995 26.6842L69.6933 25.0577C68.255 23.7425 66.3417 22.7321 63.6583 22.7321C58.8017 22.7321 54.72 26.5166 54.72 31.1679C54.72 35.8191 58.8017 39.6037 63.6583 39.6037C66.2833 39.6037 68.255 38.78 69.805 37.2349C71.3933 35.7138 71.8883 33.5749 71.8883 31.8479C71.8883 31.3116 71.8417 30.8183 71.7583 30.4065H63.6583ZM124.068 32.1958C123.6 30.9811 122.155 28.7417 119.212 28.7417C116.295 28.7417 113.867 30.9428 113.867 34.1735C113.867 37.2158 116.27 39.6037 119.492 39.6037C122.097 39.6037 123.6 38.0825 124.218 37.1966L122.285 35.9628C121.64 36.8662 120.762 37.4648 119.492 37.4648C118.23 37.4648 117.325 36.9109 116.745 35.8191L124.33 32.8135L124.068 32.1958V32.1958ZM116.335 34.0043C116.27 31.9101 118.033 30.8375 119.297 30.8375C120.287 30.8375 121.127 31.3116 121.407 31.9899L116.335 34.0043V34.0043ZM110.17 39.2733H112.663V23.3115H110.17V39.2733ZM106.087 29.9516H106.003C105.443 29.3163 104.375 28.7417 103.022 28.7417C100.182 28.7417 97.585 31.1296 97.585 34.191C97.585 37.235 100.182 39.6037 103.022 39.6037C104.375 39.6037 105.443 39.0243 106.003 38.3698H106.087V39.1488C106.087 41.2254 104.928 42.3411 103.06 42.3411C101.537 42.3411 100.592 41.2876 100.202 40.4018L98.0333 41.2685C98.6583 42.7082 100.313 44.48 103.06 44.48C105.983 44.48 108.45 42.8327 108.45 38.8247V29.0721H106.087V29.9516V29.9516ZM103.235 37.4648C101.517 37.4648 100.078 36.0873 100.078 34.191C100.078 32.2772 101.517 30.8806 103.235 30.8806C104.928 30.8806 106.263 32.2772 106.263 34.191C106.263 36.0873 104.928 37.4648 103.235 37.4648V37.4648ZM135.742 23.3115H129.778V39.2733H132.265V33.2254H135.742C138.503 33.2254 141.212 31.3116 141.212 28.2676C141.212 25.2253 138.497 23.3115 135.742 23.3115V23.3115ZM135.807 31.0051H132.265V25.5318H135.807C137.663 25.5318 138.723 27.0083 138.723 28.2676C138.723 29.5031 137.663 31.0051 135.807 31.0051ZM151.178 28.7114C149.382 28.7114 147.513 29.4712 146.745 31.1551L148.952 32.041C149.427 31.1551 150.3 30.8678 151.223 30.8678C152.513 30.8678 153.822 31.61 153.842 32.9205V33.0881C153.392 32.8391 152.428 32.4704 151.243 32.4704C148.867 32.4704 146.445 33.7234 146.445 36.0618C146.445 38.2006 148.392 39.5781 150.58 39.5781C152.253 39.5781 153.177 38.8551 153.757 38.0139H153.842V39.2477H156.243V33.1248C156.243 30.2948 154.037 28.7114 151.178 28.7114ZM150.878 37.4584C150.065 37.4584 148.932 37.0721 148.932 36.1065C148.932 34.871 150.345 34.397 151.568 34.397C152.663 34.397 153.177 34.6284 153.842 34.9333C153.647 36.4113 152.318 37.4584 150.878 37.4584V37.4584ZM164.993 29.0609L162.135 35.9804H162.05L159.095 29.0609H156.413L160.853 38.7306L158.32 44.1113H160.918L167.76 29.0609H164.993V29.0609ZM142.578 39.2733H145.072V23.3115H142.578V39.2733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9132 10.5912C13.5216 10.9839 13.2949 11.5952 13.2949 12.3869V40.6264C13.2949 41.4181 13.5216 42.0294 13.9132 42.4221L14.0099 42.5083L30.5332 26.6902V26.3167L14.0099 10.4986L13.9132 10.5912Z",
    fill: "url(#paint0_linear_177_705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0351 31.9653L30.5334 26.69V26.3165L36.0418 21.0411L36.1651 21.1098L42.6884 24.6644C44.5501 25.6732 44.5501 27.3332 42.6884 28.3484L36.1651 31.8967L36.0351 31.9653V31.9653Z",
    fill: "url(#paint1_linear_177_705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1651 31.897L30.5334 26.5035L13.9134 42.4221C14.5317 43.0446 15.5401 43.1197 16.6867 42.4972L36.1651 31.897",
    fill: "url(#paint2_linear_177_705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1651 21.1099L16.6867 10.5098C15.5401 9.89364 14.5317 9.96866 13.9134 10.5912L30.5334 26.5034L36.1651 21.1099Z",
    fill: "url(#paint3_linear_177_705)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_177_705",
    x1: 29.0661,
    y1: 40.9205,
    x2: 7.65604,
    y2: 18.5648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_177_705",
    x1: 45.1126,
    y1: 26.5014,
    x2: 12.8501,
    y2: 26.5014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_177_705",
    x1: 33.1027,
    y1: 23.5715,
    x2: 4.06891,
    y2: -6.74455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_177_705",
    x1: 9.72982,
    y1: 51.8172,
    x2: 22.6947,
    y2: 38.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 40.862,
    fill: "white",
    transform: "matrix(1.25 0 0 -1.25 0 52.0425)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSection6DownloadGoogle);
export default __webpack_public_path__ + "static/media/about_section_6_download_google.569f685eb7062a7451ecbd5e805766ad.svg";
export { ForwardRef as ReactComponent };